import apiService from "services/api";

export const resetAppState = () => {
  localStorage.clear();
  apiService.client.stop();
  apiService.client.cache.reset();
  apiService.client.clearStore();
};
